function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#1b1464",
  stroke: "#fff",
  strokeWidth: "0.3px",
  d: "M19.06 18.852h-7.027V-14.64h7.027zm40.838 0h-7.053L34.773-2.868v21.72H27.72V-14.64h7.053L52.9 7.184V-14.64h7z",
  transform: "translate(0 .15) translate(24.838 14.64)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d53d53",
  d: "M8.643 9.848v8H1.59V-15.64H17.1q6.793 0 10.8 3.539a11.867 11.867 0 0 1 4 9.348q0 5.964-3.915 9.283T17.018 9.848zm0-5.653H17.1a8.339 8.339 0 0 0 5.739-1.775 6.517 6.517 0 0 0 1.983-5.12 7 7 0 0 0-2.01-5.238A7.7 7.7 0 0 0 17.3-9.962H8.643z",
  transform: "translate(0 .15) translate(-1.59 15.64)"
}));

var SvgHGamepinLarge = function SvgHGamepinLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84.886,
    height: 33.792,
    viewBox: "0 0 84.886 33.792",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHGamepinLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/h-gamepinLarge.ab4bc4c3.svg";
export { ForwardRef as ReactComponent };